import { render, staticRenderFns } from "./BlackHoleUpgradeButton.vue?vue&type=template&id=6590e9be&scoped=true"
import script from "./BlackHoleUpgradeButton.vue?vue&type=script&lang=js"
export * from "./BlackHoleUpgradeButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6590e9be",
  null
  
)

export default component.exports